import { Component, Input, OnChanges, Renderer2, RendererFactory2, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgSelectComponent } from '@ng-select/ng-select';
import { Editor } from '@tiptap/core';
import { GlobalService } from 'app/global/global.service';
import { SessionImageService } from 'app/global/session-image.service';
import { contentBlock } from 'app/interfaces/contentBlock';
import { SelectedFieldEnum } from 'app/interfaces/fields.dto';
import { delay, of, Subscription, take } from 'rxjs';
import { Block } from '../../../../interfaces/blocks';
import { UserGalleryService } from '../../general-modals/user-gallery/user-gallery.service';
import { GeneralPopoverSettingsComponent } from '../general-popover-settings/general-popover-settings.component';
import { ContentBoxSettingsService } from './content-box-setting.service';
import { SelectedRole } from '../general-popover-settings/general-popover-settings.dto';
import { EventHandlersService } from '../../edit-template/event-handler.service';


interface IContentBoxSettingDTO {
  uuid: string
}

@Component({
  selector: 'app-content-box-settings',
  templateUrl: './content-box-settings.component.html',
  styleUrl: './content-box-settings.component.scss',
  providers: [GeneralPopoverSettingsComponent]
})
export class ContentBoxSettingsComponent implements OnChanges {
  
  @Input() data: IContentBoxSettingDTO;
  @ViewChild('roleSelecter', { static: false }) set contentboxcontent(content: NgSelectComponent) {
    if (content) {
      this.timeOutSubscription = of(null).
        pipe(
          delay(0),
          take(1)
        ).subscribe(() => {
          this.roleSelecter = content;
        })
    }
  }
  

  private renderer: Renderer2;
  public roleSelecter: NgSelectComponent;
  public convert_to_table: number = 0;
  public background_image: string = '';
  public timeOutSubscription: Subscription;
  private contentData: Block;
  public role_id: number | string = 0;
  public SelectedFieldEnum = SelectedFieldEnum;
  private currentRoute: string = '';
  private id: string = '';
  private editor:Editor;
  constructor(
    private eventHandlersService: EventHandlersService,
    private globalService: GlobalService,
    public generalPopoverSettings: GeneralPopoverSettingsComponent,
    private _userGalleryService$: UserGalleryService,
    private rendererFactory: RendererFactory2,
    private contentBoxSettingsService: ContentBoxSettingsService,
    private sessionImageService: SessionImageService,
    private route: ActivatedRoute,
  ) { this.renderer = rendererFactory.createRenderer(null, null); }

  /**
   * listen the changes whenever call the component
   * @param changes 
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes['data']) {
      this.data = changes['data'].currentValue;
      this.updateSettings();
    }
  }

  /**
   * update the settings of currect content box
   */
  async updateSettings() {
    this.currentRoute = this.route.snapshot.data['key'];
    this.id = this.route.snapshot.paramMap.get('id');
    const block = {};
    if (!this.globalService.fields_data['blocks'] || (this.globalService.fields_data['blocks'] && !this.globalService.fields_data['blocks'][this.data['uuid']])) {
      block[this.data['uuid']] = contentBlock.block({ uuid: this.data['uuid'] });
      this.globalService.fields_data['blocks'] = { ...this.globalService.fields_data['blocks'], ...block };
    }
    this.contentData = this.globalService.fields_data['blocks'][this.data['uuid']];
    this.background_image = typeof this.contentData != 'undefined' && this.contentData?.background_image ? this.sessionImageService.getTemplateImages(this.contentData.background_image, Number(this.id) ,this.globalService.getTheSectionByRoute(this.currentRoute).toLowerCase()) : '';
    this.role_id = typeof this.contentData != 'undefined' ? this.contentData.role_id : '';
    this.editor = this.globalService.editorInstances[this.data['uuid']];
    await this.generalPopoverSettings.setupAllFields();
  }


  /**
   * change the background image of content box
   * @param $event 
   */
  async backgroundImage($event) {
    if ($event.target.files.length > 0) {
      const loaderElement = document.querySelector('.upload-pdf-loader');
      try {
        if(loaderElement){
          this.renderer.removeClass(loaderElement, 'hidden');
        }
        const formData = this._userGalleryService$.collectFormData($event.target.files[0])
        this._userGalleryService$.uploadImage(formData).subscribe({
          next: (response) => {
            this.background_image = this.sessionImageService.getTemplateImages(response?.image, Number(this.id) ,this.globalService.getTheSectionByRoute(this.currentRoute).toLowerCase());
            this.contentBoxSettingsService.setContentBoxImage(this.data['uuid'], response?.image, true, this.background_image);
            this.renderer.addClass(loaderElement, 'hidden');
          }
        });
      }
      catch (error) {
        this.renderer.addClass(loaderElement, 'hidden');
      }
    }
  }


  
  closeOpenedDropdown(){
    this.roleSelecter.close();
  }

  
  
  /**
   * remove the content box background image
   */
  removeBackgroundImage() {
    this.contentBoxSettingsService.removeContentBoxIamge(this.data['uuid']);
    this.background_image = ''
  }

  /** Close external right menu */
  close() {
    this.eventHandlersService.triggerEditorSideMenu({}, 'DEFAULT');
  }

  /**
  * select role for allow edit on signing area 
  */
  selectRole(roleId: SelectedRole) {
    this.contentData = this.globalService.updateBlock(this.data['uuid'], { role_id: roleId.id });
  }

  onLockChange(checked:boolean) {
    if(this?.editor){
      this.editor.setEditable(!checked);
    }
  }

}
